export default __webpack_public_path__ + "static/loupe-design-system-sheets-pattern-907d9db6b7297d0e1964d06f2856b81a.png";